var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgReceiptLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.33268L5 1.66602L2.5 3.33268V15.8327C2.5 17.2134 3.61929 18.3327 5 18.3327H16.6667C18.0474 18.3327 19.1667 17.2134 19.1667 15.8327V13.3327H17.5V3.33268L15 1.66602L12.5 3.33268L10 1.66602L7.5 3.33268ZM15.8333 13.3327H5.83333V15.8327C5.83333 16.2929 5.46023 16.666 5 16.666C4.53977 16.666 4.16667 16.2929 4.16667 15.8327V4.22466L5 3.6691L7.5 5.33577L10 3.6691L12.5 5.33577L15 3.6691L15.8333 4.22466V13.3327ZM16.6667 16.666H7.35774C7.44988 16.4053 7.5 16.1248 7.5 15.8327V14.9993H17.5V15.8327C17.5 16.2929 17.1269 16.666 16.6667 16.666Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReceiptLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/receipt-line.9deb80ad.svg";
export { ForwardRef as ReactComponent };